export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-ticket-3f45aa820a92be407fd23dceadae9a42.svg";